import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" {...this.props}><path fill="none" stroke="#747474" strokeMiterlimit="10" d="M24.5 26.325a.768.768 0 0 1-.768.768H12.267a.768.768 0 0 1-.767-.768V17.86c0-.424.344-.768.767-.768h11.465c.424 0 .768.343.768.768v8.465z" /><path fill="none" stroke="#747474" strokeMiterlimit="10" d="M13.5 17.593v-2.561c0-2.503 1.768-4.532 4.269-4.532 2.502 0 4.731 2.029 4.731 4.532v2.561" /><circle fill="none" stroke="#747474" strokeLinecap="round" strokeMiterlimit="10" cx="18" cy="21.501" r="1.201" /><path fill="none" stroke="#747474" strokeLinecap="round" strokeMiterlimit="10" d="M18 22.703v1.861" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/assets/icons/locked.svg